import {
  INTAKE_STATUS_OPTIONS,
  YES_NO_OPTIONS,
  STATUS_FILTER,
  CLIENT_FILTER,
  ITEM_FILTER,
  RECEIVED_BY_FILTER,
} from "../../../custom/Utils/ListFilterOptions";

const schema = localStorage.getItem("schema");
export const basicFormData = () => ({
  inputData: {
    intake_no: "",
    material_id: "",
    customer_id: null,
    incoming_invoice_no: "",
    received_date: "",
    received_by: "",
    status: "Pending",
    material_serial_no: "",
    is_repairable: null,
    technician_id: "",
    items_matching_invoice: null,
    comments: "",
    anti_static_bag: null,
    fault_tag_attached: null,
    fault_reported_from_field: "",
    branch_id: "",
    zone_id: "",
    rate_per_unit: "",

    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "material_intakes",
    schema: schema,
    include: [
      {
        model: "material_masters",
        as: "material",
      },

      {
        model: "user_masters",
        as: "received_by_user",
      },
      {
        model: "user_masters",
        as: "inspected_by_user",
      },
      {
        model: "job_cards",
        as: "job_cards",
        required: false,
        include: [
          {
            model: "user_masters",
            as: "technician",
          },
        ],
      },
    ],
  };

  const navigatePage = { back: "/item-intakes-list" };

  const headerName = "Item Intakes";

  const validationType = "MaterialIntakesCreate";
  const createEndpoint = "/updaterelationaldata  ";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "material_intakes",
    schema: schema,
    include: [
      {
        model: "material_masters",
        as: "material",
      },

      {
        model: "client_masters",
        as: "customer",
      },
      {
        model: "user_masters",
        as: "received_by_user",
      },
      {
        model: "user_masters",
        as: "inspected_by_user",
      },
      {
        model: "job_cards",
        as: "job_cards",
        required: false,
        include: [
          {
            model: "user_masters",
            as: "technician",
          },
        ],
      },
    ],
  };

  const columnData = [
    { label: "Sr.no", value: "index" },
    { label: "GMDS Code", value: "material.gmds_code" },
    { label: "Serial Number", value: "material_serial_no" },
    { label: "Intake Number", value: "intake_no" },
    { label: "Job Card", value: "job_cards[0].job_card_no" },
    { label: "Is Repairable", value: "is_repairable" },
    { label: "Engineer", value: "job_cards[0].technician.full_name" },
    { label: "Items Matching Invoice", value: "items_matching_invoice" },
    { label: "Anti Static Bag", value: "anti_static_bag" },
    { label: "Fault Tag Attached", value: "fault_tag_attached" },
    { label: "Fault Reported From Field", value: "fault_reported_from_field" },
    { label: "Rate Per Unit", value: "rate_per_unit" },
    { label: "Received By", value: "received_by_full_name" },
    { label: "Received Date", value: "received_date" },
    { label: "Status", value: "status" },
    { label: "Is Active", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/item-intakes-create",
    edit: "/item-intakes-create",
    view: "/item-intakes-view",
  };

  // every column shown in the list has to be reachable from the search box.
  // nested paths use the association alias (`job_cards.technician.first_name`),
  // NOT the array notation used by the column accessors.
  const searchfields = [
    "intake_no",
    "material_serial_no",
    "material.gmds_code",
    "customer.client_name",
    "fault_reported_from_field",
    "rate_per_unit",
    "status",
    "inspected_by_user.first_name",
    "inspected_by_user.last_name",
    "received_by_user.first_name",
    "received_by_user.last_name",
    "job_cards.job_card_no",
    "job_cards.technician.first_name",
    "job_cards.technician.last_name",
  ];

  const headerName = "Item Intakes";
  const endpoint = "/getRecords";
  const exportFileName = "MaterialIntakesData.xlsx";

  const filterConfig = [
    {
      key: "status",
      label: "Intake Status",
      width: 185,
      options: INTAKE_STATUS_OPTIONS,
    },
    ITEM_FILTER,
    CLIENT_FILTER,
    RECEIVED_BY_FILTER,
    { key: "is_repairable", label: "Repairable", width: 155, options: YES_NO_OPTIONS },
    STATUS_FILTER,
  ];

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
    filterConfig,
  };
};

export const exportPageData = {
  modelName: "material_intakes",
  schema: schema,
  include: [
    { model: "material_masters", as: "material" },
    { model: "client_masters", as: "customer" },
    { model: "user_masters", as: "received_by_user" },
    { model: "user_masters", as: "inspected_by_user" },
  ],
  pagination: { page: 1, pageSize: 10000 },
};
